import { AccountInputEventsService } from '../services/input-events.service'
import { inputAreaSetActive } from './inputs'

/**
 * set Enter / Tab  press event on inputs
 * @param i - index of element formControlsInputId
 */
export function enterAndTabHandler(document: Document, inputList: string[], event, i): void {
  if (event.key === 'Enter' || (event.key === 'Tab' && !event.shiftKey)) {
    const nextId = inputList[i + 1]
    const el = document.getElementById(nextId)
    if (!el) {
      return
    }
    event.preventDefault()
    el.click()
    el.focus()

    inputAreaSetActive(el.parentElement)
  }
}


/**
 * set Shift + Tab event on inputs
 * @param i - index of element formControlsInputId
 */
export function shiftTabHandler(document: Document, inputList: string[], event, i): void {
  if (event.key === 'Tab' && event.shiftKey) {
    const nextId = inputList[i - 1]
    const el = document.getElementById(nextId)
    if (!el) {
      return
    }
    event.preventDefault()
    el.click()
    inputAreaSetActive(el.parentElement)
  }
}
